
import { createClient } from '@supabase/supabase-js';
import { SUPABASE_CONFIG } from '../constants';
import { EarlyAccessRequest } from '../types';

const supabase = createClient(SUPABASE_CONFIG.url, SUPABASE_CONFIG.key);

export const submitEarlyAccess = async (data: EarlyAccessRequest) => {
  const { error } = await supabase
    .from('early_access_requests')
    .insert([{
      college_name: data.college_name,
      contact_person: data.contact_person,
      email: data.email,
      message: data.message
    }]);

  if (error) throw error;
  return true;
};
